import AdminLayout from "@/views/admin/AdminLayout.vue"
import Bills from "@/views/admin/purchases/BillList.vue"
import BillInfo from "@/views/admin/purchases/BillInfo.vue"
import BillForInvoice from "@/views/admin/purchases/BillForInvoice.vue"
import InvoiceViewCustomer from "@/views/admin/sales/InvoiceViewCustomer.vue"

const routes = [
  {
    path: "/:lang/bills",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "Bills",
        meta: {
          title: "Bills.__Bill",
          requireAuth: true,
          auth: 0
        },
        props: route => ({
          ...route.params
        }),
        component: Bills
      },
      {
        path: "new",
        name: "BillNew",
        meta: {
          title: "Bills.__AddBill",
          requireAuth: true,
          auth: 0
        },
        component: BillInfo
      },
      {
        path: "edit/:id",
        name: "BillEdit",
        meta: {
          title: "Bills.__EditBill",
          requireAuth: true,
          auth: 0
        },
        component: BillInfo,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "new-for-invoice",
        name: "BillForInvoice",
        meta: {
          title: "Bills.__AddBillForInvoice",
          requireAuth: true,
          auth: 0
        },
        component: BillForInvoice,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "received-invoice/view",
        name: "ViewReceivedInvoice",
        meta: {
          title: "Bills.__ReceivedInvoices",
          requireAuth: true,
          auth: 0
        },
        component: InvoiceViewCustomer,
        props: route => ({
          ...route.params
        })
      }
    ]
  }
]

export default routes
